import React from 'react';

import { Format } from '@/domain/app';

import { DebitAccount, User } from '@generated-types';
import useText from '@hooks/use-text';

interface SummaryCardContentProps {
    prettyCardName: string;
    prettyCardNumber: string;
    prettyAccountNumber: string;
    selectedAccount?: DebitAccount;
    customer?: User;
}

const SummaryCardContent = ({
    prettyCardName,
    prettyCardNumber,
    prettyAccountNumber,
    selectedAccount,
    customer,
}: SummaryCardContentProps) => {
    const { summaryCardInfo, summaryCardCreditTransfer, summaryCardSmsConfirmation, summaryCardNotice } = useText();

    const splitInfoText = summaryCardInfo
        .replace('{cardName}', prettyCardName)
        .replace('{cardNumber}', prettyCardNumber)
        .replace('{accountNumber}', prettyAccountNumber)
        .split('|?|');

    const splitTransferText =
        selectedAccount &&
        summaryCardCreditTransfer
            .replace('{accountName}', `${selectedAccount?.productName}`)
            .replace('{accountNumber}', `${Format.accountNumber(selectedAccount?.number)}`)
            .split('|?|');

    const splitSmsConfirmation =
        customer && summaryCardSmsConfirmation.replace('{mobileNumber}', `${customer.contact.mobile}`).split('|?|');
    return (
        <>
            <p className="typography-paragraph">
                {splitInfoText[0]}
                <br />
                {splitInfoText[1]}
                <br />
                <b>{splitInfoText[2]}</b>
                <br />
                {splitInfoText[3]} <b>{splitInfoText[4]}</b>
            </p>
            {splitTransferText && (
                <p>
                    {splitTransferText[0]}
                    <br /> <b>{splitTransferText[1]}</b>
                </p>
            )}
            {splitSmsConfirmation && (
                <p>
                    {splitSmsConfirmation[0]} <b>{splitSmsConfirmation[1]}</b> {splitSmsConfirmation[2]}
                </p>
            )}
            <p>{summaryCardNotice}</p>
        </>
    );
};

export default SummaryCardContent;
